export enum ResponsableType {
    INFORMER = 1,
    RESPONSABLE = 2,
}